import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Team")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Monarch is made possible thanks to a diverse and dedicated team of biologists, scientists, and programmers from various schools and institutes. ", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Funding")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" OFFICE OF THE DIRECTOR, NATIONAL INSTITUTES OF HEALTH ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" The Monarch Initiative: Linking diseases to model organism resources")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 2R24OD011883-10A1 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" NATIONAL HUMAN GENOME RESEARCH INSTITUTE, Center of Excellence in Genome Sciences ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" A phenomics-first resource for interpretation of variants ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 7RM1HG010860-02 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" NATIONAL HUMAN GENOME RESEARCH INSTITUTE ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" The Human Phenotype Ontology: Accelerating Computational Integration of Clinical Data for Genomics")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 1U24HG011449-01A1 ")

import { kebabCase } from "lodash";
import AppMember from "@/components/AppMember.vue";
import team from "./team.json";
import AppGroup from "@/components/AppGroup.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PageTeam',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_AppHeading = _resolveComponent("AppHeading")!
  const _component_AppLink = _resolveComponent("AppLink")!
  const _component_AppSection = _resolveComponent("AppSection")!
  const _component_AppGallery = _resolveComponent("AppGallery")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeading, null, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _hoisted_2,
        _createElementVNode("p", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(team), (group, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createVNode(_component_AppLink, {
                to: '#' + _unref(kebabCase)(group.name)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(group.name), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              (index !== _unref(team).length - 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " · "))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(team), (group, groupIndex) => {
      return (_openBlock(), _createBlock(_component_AppSection, {
        key: groupIndex,
        width: "big"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AppHeading, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(group.name), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(AppGroup, {
            name: group.name,
            link: group.link
          }, null, 8, ["name", "link"]),
          (!group.type)
            ? (_openBlock(), _createBlock(_component_AppGallery, { key: 0 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.members, (member, memberIndex) => {
                    return (_openBlock(), _createBlock(AppMember, {
                      key: memberIndex,
                      name: member.name,
                      role: 'role' in member ? member.role : '',
                      link: member.link
                    }, null, 8, ["name", "role", "link"]))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            : (_openBlock(), _createBlock(_component_AppGallery, { key: 1 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.members, (member, memberIndex) => {
                    return (_openBlock(), _createBlock(AppGroup, {
                      key: memberIndex,
                      name: member.name,
                      link: member.link
                    }, null, 8, ["name", "link"]))
                  }), 128))
                ]),
                _: 2
              }, 1024))
        ]),
        _: 2
      }, 1024))
    }), 128)),
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeading, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _hoisted_5,
            _hoisted_6,
            _createVNode(_component_AppLink, { to: "https://reporter.nih.gov/project-details/10173498" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _hoisted_8,
            _hoisted_9
          ]),
          _createElementVNode("li", null, [
            _hoisted_10,
            _hoisted_11,
            _createVNode(_component_AppLink, { to: "https://reporter.nih.gov/project-details/10448140" }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _hoisted_13,
            _hoisted_14
          ]),
          _createElementVNode("li", null, [
            _hoisted_15,
            _hoisted_16,
            _createVNode(_component_AppLink, { to: "https://reporter.nih.gov/project-details/10269338" }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }),
            _hoisted_18,
            _hoisted_19
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})